import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";
import { extrairFoto3mf } from "./extract3mf";

// Sobe uma imagem em base64 (dataURL) pro Storage como um item de galeria de
// verdade ({path,url}) — usado pra semear a galeria já na hora do registro
// do produto na Calculadora, e pelo thumbnail extraído do .3mf.
export async function salvarFotoBase64NoStorage(produtoId, base64, prefixo = "foto") {
  if (!base64) return null;
  try {
    const blob = await (await fetch(base64)).blob();
    const path = `produtos/${produtoId}/${Date.now()}_${prefixo}.jpg`;
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, blob);
    const url = await getDownloadURL(storageRef);
    return { path, url };
  } catch { return null; }
}

// "Confere" se o produto tem uma foto principal e, se não tiver, tenta
// arrumar sozinho a partir do que já existe — sem pedir nada pro usuário:
//  1. já tem fotoBase64 → nada a fazer.
//  2. tem fotos na galeria mas a miniatura não bate (raro, ex.: edição manual
//     do banco) → usa a própria URL da 1ª foto (sem precisar baixá-la de
//     volta — isso dependeria de CORS estar liberado no bucket do Storage,
//     que não está por padrão, e falharia silenciosamente).
//  3. não tem foto nenhuma mas tem um .3mf anexado → extrai o thumbnail
//     embutido nele e usa como capa (fotoBase64) — SEM entrar no carretel
//     de fotos (array `fotos`), que fica só pras fotos reais que o vendedor
//     adiciona. Assim que a primeira foto de verdade entrar na galeria, ela
//     substitui esse thumbnail como capa (ver Produtos.jsx). Esse caso
//     PRECISA baixar o .3mf de volta do Storage pra poder abrir o zip — não
//     tem como contornar o CORS aqui; se o bucket não tiver CORS liberado
//     pra origem atual, esse passo falha silenciosamente (o resto do app
//     continua funcionando normalmente, só não consegue "adivinhar" a foto
//     desse produto específico).
// Retorna o patch pra gravar no Firestore, ou null se não tinha o que fazer.
export async function garantirFotoPrincipal(produto) {
  if (produto.fotoBase64) return null;
  // Já tentou antes (marcado por esta própria função) — não tenta de novo
  // mesmo que, por qualquer motivo (reload lendo um snapshot velho, escrita
  // anterior que falhou em silêncio etc.), `fotoBase64` volte a aparecer
  // vazio aqui. Sem essa trava, cada vez que essa função rodasse de novo
  // criava um NOVO upload duplicado do thumbnail do .3mf no Storage.
  if (produto.fotoLegadaMigrada) return null;

  if (produto.fotos?.length > 0) {
    return { fotoBase64: produto.fotos[0].url };
  }

  const arq3mf = (produto.arquivos || []).find(a => (a.nome || "").toLowerCase().endsWith(".3mf"));
  if (!arq3mf) return null;
  try {
    const blob = await (await fetch(arq3mf.url)).blob();
    const thumb = await extrairFoto3mf(blob);
    if (!thumb) return null;
    const foto = await salvarFotoBase64NoStorage(produto.id, thumb, "thumb-3mf");
    return { fotoBase64: foto?.url || thumb, fotoLegadaMigrada: true };
  } catch { return null; }
}
